/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Debt_AmountInputs */

const en_case_field_debt_amount = /** @type {(inputs: Case_Field_Debt_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

const pt_br2_case_field_debt_amount = /** @type {(inputs: Case_Field_Debt_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

/**
* | output |
* | --- |
* | "Value" |
*
* @param {Case_Field_Debt_AmountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_debt_amount = /** @type {((inputs?: Case_Field_Debt_AmountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Debt_AmountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_debt_amount(inputs)
	return pt_br2_case_field_debt_amount(inputs)
});